import { createFileRoute } from '@tanstack/react-router';
import { TeamAttendancePage } from '@/features/attendance/attendance-pages';
import { guardRoute } from '@/lib/route-guards';

/** `/team/attendance` (FR-ATT-11, FR-WFH-5): my reporting tree today, by month and WFH. */
export const Route = createFileRoute('/_app/team_/attendance')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/team/attendance');
  },
  component: TeamAttendancePage,
});
